import { ClassNameProps } from "@/types";

/**
 * Sizes for the TileProgressBar component.
 * M - Used in medium and 3:4 tiles
 * L - Used in L and XL Tiles
 */
enum TileProgressBarSize {
  Medium = "medium",
  Large = "large",
}

/**
 * Styles for the TileProgressBar component.
 * Floating - Use when the progress bar does not touch the edges of the tile.
 * Bottom Fixed - Use when the progress bar is fixed to the bottom and hugs the edges of the tile.
 */
enum TileProgressBarStyle {
  Floating = "floating",
  BottomFixed = "bottom-fixed",
}

interface TileProgressBarProps
  extends ClassNameProps,
    React.HTMLAttributes<HTMLDivElement> {
  size: TileProgressBarSize;
  barStyle: TileProgressBarStyle;
  progress: number;
}

export { TileProgressBarSize, TileProgressBarStyle };
export type { TileProgressBarProps };
